import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'

const study: AppRouteModule = {
  path: '/study',
  name: 'Study',
  component: LAYOUT,
  redirect: '',
  meta: {
    icon: 'icon-xuexiguanli',
    title: '学习管理',
    code: 'B0201,B020302,B020201',
  },
  children: [
    {
      path: '/study/goods',
      name: 'StudyGoods',
      component: () => import('/@/views/study/goods/index.vue'),
      meta: {
        title: '商品学习',
        code: 'B0201',
      },
    },
    {
      path: '/study/simulation',
      name: 'Simulation',
      component: () => import('/@/views/study/simulation/index.vue'),
      meta: {
        title: '模拟训练',
        code: 'B020302',
        noKeepAlive: true,
      },
    },
    {
      path: '/study/simulation/detail',
      name: 'SimulationDetail',
      component: () => import('/@/views/study/simulation/detail.vue'),
      meta: {
        title: '训练详情',
        code: 'B020201',
        belong: '/study/simulation',
        hideMenu: true,
        noKeepAlive: true,
      },
    },
    {
      path: '/study/simulation/add',
      name: 'SimulationAdd',
      component: () => import('/@/views/study/simulation/add.vue'),
      meta: {
        title: '创建训练任务',
        code: 'B020201',
        belong: '/study/simulation',
        hideMenu: true,
        noKeepAlive: true,
      },
    },
    {
      path: '/study/simulation/exam',
      name: 'SimulationExam',
      component: () => import('/@/views/study/simulation/exam/index.vue'),
      meta: {
        title: '答题',
        code: 'B020201',
        belong: '/study/simulation',
        noKeepAlive: true,
        hideMenu: true,
      },
    },
    {
      path: '/study/simulation/exam/result',
      name: 'SimulationExamResult',
      component: () => import('/@/views/study/simulation/exam/result.vue'),
      meta: {
        title: '测试结果',
        code: 'B020201',
        belong: '/study/simulation',
        noKeepAlive: true,
        hideMenu: true,
      },
    },
    {
      path: '/study/train',
      name: 'StudyTrain',
      component: () => import('/@/views/study/train/index.vue'),
      meta: {
        title: '抽检练习',
        code: 'B020201',
      },
    },
    {
      path: '/study/train/detail',
      name: 'TrainDetail ',
      component: () => import('/@/views/study/train/detail.vue'),
      meta: {
        title: '训练详情',
        code: '',
        hideMenu: true,
        belong: '/study/train',
      },
    },
    {
      path: '/study/train/identify',
      name: 'TrainIdentify ',
      component: () => import('/@/views/study/train/identify.vue'),
      meta: {
        title: '识别详情',
        code: '',
        hideMenu: true,
        belong: '/study/train',
      },
    },
  ],
}

export default study
